/* eslint-disable sort-keys */
/* get the Merchant country code from vInit or from Merchant config.
 * Precedence given to countryCode obtained from vInit Request
 */
/**
 *
 * @param {object} vInitRequest
 * @param {object} merchantConfig
 * @returns {string} countryCode
 */
const getMerchantCountryCode = (vInitRequest, merchantConfig) => {
  const { countryCode } = vInitRequest || {};
  const { merchantCountryCode } = merchantConfig || {};
  return countryCode || merchantCountryCode;
};

export default getMerchantCountryCode;
